import notReport from './notReport'
import notResend from './notResend'

const hideManualActionEmails = emails => emails.filter(notReport).filter(notResend)

export default hideManualActionEmails
